import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux'
import React, { Fragment, useState } from 'react'
import { v4 as uuidv4 } from 'uuid';
import Tooltip from '@mui/material/Tooltip';
import moment from 'moment'
import { obtenerClientesParaDictamen, obtenerClienteParaDictamenes } from '../../../redux/DucksAtencionACliente/UsuariosAtencionAClienteDuck';
import HistorialMarcarioComponent from './HistorialMarcarioComponent';

const SolicitudesDictamenesComponent = (props) => {

    const solicitudes = useSelector(store => store.UsuariosAtencionACliente.solicitudesDictamenes)
    const fechaHoy = moment().format('YYYY-MM-DD')
    const dispatch = useDispatch()
    const dataUser = useSelector(store => store.Usuario.user)
    React.useEffect(async () => {
        await dispatch(obtenerClientesParaDictamen())
    }, [])

    const [openModalHistorial, setOpenModalHistorial] = React.useState(false)
    const [dataHistorial, setDataHistorial] = React.useState([])

    const columns = [
        { field: 'num', headerName: 'Id', width: 70, headerAlign: 'center' },
        { field: 'numeroSocio', headerName: 'N° de Socio', width: 105, headerAlign: 'center' },
        {
            field: 'nombreRazon', headerAlign: 'center', headerName: 'Razón social', width: 250,
            renderCell: (params) =>
                <Tooltip title={`${params.row.nombreRazon}`} arrow>
                    <label>{`${params.row.nombreRazon}`}</label>
                </Tooltip>
        },
        {
            field: 'cadena', headerName: 'Cadena Productiva', width: 350, headerAlign: 'center',
            renderCell: (params) => (
                <Tooltip title={params.row.cadena} >
                    <span className="csutable-cell-trucate">{params.row.cadena}</span>
                </Tooltip>
            )
        },
        {
            field: 'informeFiscal', headerName: 'Informe Fiscal', width: 125, headerAlign: 'center',
            renderCell: (params) =>
                <div>{`${params?.row?.informeFiscal}`}</div>
        },
        {
            field: 'informeJuridico', headerName: 'Informe Juridico', width: 140, headerAlign: 'center',
            renderCell: (params) =>
                <div>{`${params.row.personafisica ? '---------' : params?.row?.informeJuridico}`}</div>
        },
        {
            field: 'informeMarcario', headerName: 'Informe Marcario', width: 145, headerAlign: 'center',
            renderCell: (params) =>
                <button className={`btn btn-outline-success`} onClick={() => detalleMarcario(params)}>Detalle</button>
        },
        {
            field: 'accion', headerName: 'Acción', width: 115, headerAlign: 'center',
            renderCell: (params) =>
                <button className={`btn btn-outline-success`} onClick={() => infoSolicitud(params)}>Dictaminar</button>
        },
    ]
    const detalleMarcario = (params) => {
        setOpenModalHistorial(true)
        setDataHistorial(params.row.historial)
    }
    /**
     *{
                field: 'representanteLegal', headerName: 'Representante Legal', width: 240, headerAlign: 'center',
                renderCell: (params) => (
                    <Tooltip title={params.row.representanteLegal} >
                        <span className="csutable-cell-trucate">{params.row.representanteLegal}</span>
                    </Tooltip>
                )
            },
            { field: 'estado', headerName: 'Estado', width: 150, headerAlign: 'center' },
     * 
     */
    const infoSolicitud = async (params) => {
        await dispatch(obtenerClienteParaDictamenes(params.row.idcliente))
        props.history.push('/PanelDictamenesComponent')
    }

    const rows = []
    let numUser = 1


    solicitudes?.map(usuario => {
        let cadena = ''
        for (const i in usuario?.actividadcliente) {
            if (cadena === '') cadena += usuario?.actividadcliente?.[i]?.tipoactividad?.actividad
            else cadena += ',' + usuario?.actividadcliente?.[i]?.tipoactividad?.actividad
        }
        let arregloCadena = cadena.split(',')
        let combinacionCadena = ''
        let contador = 1
        for (const i in arregloCadena) {
            if (arregloCadena.length === 1) {
                combinacionCadena += arregloCadena[i]
            } else {
                if (arregloCadena.length === (contador + 1)) {
                    combinacionCadena += arregloCadena[i] + ' y '
                    contador++
                } else {

                    combinacionCadena += arregloCadena[i]
                    if (arregloCadena.length !== contador) {
                        combinacionCadena += ', '
                    }
                    contador++
                }

            }

        }

        let alertaFechaVencimiento = false
        let alertaMarcaSinDictamenMarcario = false
        let alertaCambioAño = false
        let alertaFc_36 = false //Si existe un cambio en la marca del dictamen marcario, cambio de razón social (F J M) o cambio de representante legal (M J).

        let fechasLimite = []

        let diasFiscal = moment(fechaHoy).diff(moment(usuario?.dictamenfiscalcliente?.[0]?.fechasolicitud.substring(0, 10)), 'days')
        let diasJuridico = moment(fechaHoy).diff(moment(usuario?.dictamenjuridicocliente?.[0]?.fechasolicitud.substring(0, 10)), 'days')
        let diasMarcario = []

        usuario?.dictamenmarcariocliente?.map(dictamenMarcario => {
            moment(fechaHoy).diff(moment(dictamenMarcario?.fechasolicitud.substring(0, 10)), 'days') >= 365 ? diasMarcario.push(true) : diasMarcario.push(false)
            moment(dictamenMarcario?.fechavigencia.substring(0, 10)).diff(fechaHoy, 'days') == 1 ? fechasLimite.push(true) : fechasLimite.push(false)
        })

        if (fechasLimite.includes(true)) {
            alertaFechaVencimiento = true
        }

        if (diasFiscal >= 365 || diasJuridico >= 365 || diasMarcario.includes(true)) {
            alertaCambioAño = true
        }
        let informeFiscal = ''
        if (usuario?.dictamenfiscalcliente?.length > 0) informeFiscal = usuario?.dictamenfiscalcliente?.[0]?.numeroinforme
        let informeJuridico = ''
        if (usuario?.dictamenjuridicocliente?.length > 0) informeJuridico = usuario?.dictamenjuridicocliente?.[0]?.numeroinforme
        let informeMarcario = ''
        usuario?.dictamenmarcariocliente?.map(dictamenMarcario => {
            informeMarcario += dictamenMarcario?.numeroinforme + ' ' + dictamenMarcario?.marcaregistrada + '\n'
        })

        let historial = []
        if (usuario.dictamenmarcariocliente.length > 0) {
            for (const i in usuario.dictamenmarcariocliente) {
                let info = usuario?.dictamenmarcariocliente?.[i]
                let historialInfo = { informe: info?.numeroinforme, marca: info?.marcaregistrada }
                historial.push(historialInfo)
            }
        }
        if (usuario.marcascliente.length > 0) {
            for (const i in usuario.marcascliente) {
                let info = usuario?.marcascliente?.[i]
                if (!info.isdictamenmarcario) {
                    let historialInfo = { informe: '', marca: info?.marca }
                    historial.push(historialInfo)
                }
            }
        }
        if (usuario.marcasproductoconmezcalcliente.length > 0) {
            for (const i in usuario.marcasproductoconmezcalcliente) {
                let info = usuario?.marcasproductoconmezcalcliente?.[i]
                if (!info.isdictamenmarcario) {
                    let historialInfo = { informe: '', marca: info?.marca }
                    historial.push(historialInfo)
                }
            }
        }

        rows.push({
            id: uuidv4(), idcliente: usuario.idcliente, num: numUser, numeroSocio: usuario?.numerosocio, nombreRazon: usuario?.nombrerazonsocial,
            cadena: combinacionCadena, representanteLegal: usuario?.nombrerepresentantelegal, estado: usuario?.domiciliofiscalcliente?.[0]?.estado,
            alertaFechaVencimiento: alertaFechaVencimiento, alertaMarcaSinDictamenMarcario: alertaMarcaSinDictamenMarcario,
            alertaCambioAño: alertaCambioAño, alertaFc_36: alertaFc_36, informeFiscal: informeFiscal, informeJuridico: informeJuridico,
            personafisica: usuario?.personafisica, informeMarcario: informeMarcario, historial: historial
        })
        numUser++
    })
    function QuickSearchToolbar() {
        return (
            <Box
                sx={{ p: 0.5, pb: 0, mb: 2, textAlign: 'left', height: 30, width: '100%', backgroundColor: 'white', textAlign: 'end' }}>
                <GridToolbarQuickFilter style={{ width: '25%', }} placeholder='Búsqueda...' />
            </Box>
        );
    }

    return (
        <div className="container text-center">
            <h3><b>DICTAMENES</b></h3>
            <Box sx={{ height: 650, width: '100%' }}>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    disableColumnMenu={true}
                    components={{ Toolbar: QuickSearchToolbar }}
                    initialState={{ sorting: { sortModel: [{ field: 'fecha', sort: 'desc' }], }, }}
                    pageSize={10}
                    getRowClassName={(params) => {
                        if (params.row.alertaFechaVencimiento) {
                            return "alertaRoja"
                        } /*else if (params.row.alertaMarcaSinDictamenMarcario) {
                            return "alertaVerde"
                        } else if (params.row.alertaCambioAño) {
                            return "alertaAzul"
                        } else if (params.row.alertaFc_36) {
                            return "alertaAmarilla"
                        }*/
                    }}
                    sx={{
                        boxShadow: 0,
                        color: 'black',
                        border: 0,
                        backgroundColor: 'white',
                        '& .MuiDataGrid-cell': {
                            display: 'block',
                            position: 'relative',
                            textAlign: 'center',
                        },
                        '& .MuiDataGrid-columnHeaders': {
                            background: '#c88b3e',
                            color: 'white',
                            fontFamily: 'Montserrat',
                            fontWeight: 'bold',
                            height: '20px'
                        },
                        ".alertaRoja": {
                            background: '#FA9696',
                            border: '2px solid #FF7F7F',
                            "&:hover": {
                                background: "#FF7F7F"
                            }
                        },
                        ".alertaVerde": {
                            background: '#AAFF9D',
                            border: '2px solid #7DE86C',
                            "&:hover": {
                                background: "#7DE86C"
                            }
                        },
                        ".alertaAzul": {
                            background: '#C5E8FD',
                            border: '2px solid #9ED8FE',
                            "&:hover": {
                                background: "#9ED8FE"
                            }
                        },
                        ".alertaAmarilla": {
                            background: '#FFF8B0',
                            border: '2px solid #FFED78',
                            "&:hover": {
                                background: "#FFED78"
                            }
                        },
                    }}
                />
            </Box>
            {openModalHistorial &&
                <HistorialMarcarioComponent setOpenModalHistorial={{ setOpenModalHistorial }} historial={dataHistorial}></HistorialMarcarioComponent>
            }
        </div>
    );

};

export default SolicitudesDictamenesComponent

